import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from '@meddata/core/services';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
	private readonly auth = inject(AuthService);
	title = environment.production ? 'MedData Prod' : 'MedData Dev';

	ngOnInit() {
		this.auth.getInfoFromLocalStorage();
	}
}
